import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import SidebarItem from './SidebarItem'
import Icon from './../../Icons'

export class DropdownList extends Component {
  constructor(props) {
    super(props)

    this.handleSelect = this.handleSelect.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.renderSearch = this.renderSearch.bind(this)
    this.renderDropdownItems = this.renderDropdownItems.bind(this)
    this.renderSelection = this.renderSelection.bind(this)
    this.renderSelectedItems = this.renderSelectedItems.bind(this)
    this.renderSelectAll = this.renderSelectAll.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleInput = this.handleInput.bind(this)

    this.state = {
      search: '',
      opened: false,
    }
    this.wrapperRef = createRef()
    this.searchRef = createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.state.opened) {
        this.setState({ opened: false })
      }
    }
  }

  handleSelect(item) {
    this.props.onSelect(this.props.name, item, this.props.options.allowMultiple)
    if (this.props.options.closeAfterSelect) {
      this.setState({ opened: false })
    }
  }

  handleSelectAll() {
    this.props.onSelectAll(this.props.name)
  }

  handleClick(e) {
    e.stopPropagation()
    if (this.state.opened) {
      this.setState({ opened: false, search: '' })
    } else {
      this.setState({ opened: true, search: '' })
    }
  }

  handleInput(e) {
    e.preventDefault()
    const name = e.target.name
    const value = e.target.value
    if (this.props.onSearch) {
      this.props.onSearch(value)
    }
    this.setState({ [name]: value })
  }

  renderSelectedItems() {
    const { filters, name, options, selectAllText, explicit, t } = this.props
    const selection = explicit ? filters : filters[name]
    if (selection.length === 0 && options.selectAllByDefault) {
      const names = name.split(' ')
      let filterItem = {}
      if (this.props.isNotification) {
        filterItem = {
          text: t('calendar:dropdownList.toAll'),
          avatar: options.filterAllAvatar,
        }
      } else {
        filterItem = {
          text: selectAllText || 'All ' + names[names.length - 1] + 's',
          avatar: options.filterAllAvatar,
        }
      }
      return (
        <SidebarItem
          item={filterItem}
          type={'selection'}
          isSelected={true}
          isFilter={true}
          onSelect={() => {}}
          controls={false}
        />
      )
    }
    if (!options.selectAllByDefault && selection.length === 0) {
      return <p> {t('calendar:dropdownList.noItemsSelected')} </p>
    }
    return selection.map((item) => {
      return (
        <SidebarItem
          key={item.id}
          item={item}
          type={'selection'}
          isSelected={true}
          onSelect={this.handleSelect}
          controls={true}
          isFilter={false}
        />
      )
    })
  }

  renderSelection() {
    const { t } = this.props
    if (this.props.options.hasSelection) {
      return <div className="ctp-sidebar-selection">{this.renderSelectedItems()}</div>
    } else if (this.props.sidebarOption) {
      return (
        <div className="ctp-sidebar-selection">
          <p> {t('calendar:dropdownList.noItemsSelected')}</p>
        </div>
      )
    }
  }

  renderSearch() {
    const { t } = this.props
    if (this.props.options.hasSearch) {
      return (
        <span>
          <input
            className="ctp-dropdown__content-search"
            type="text"
            name="search"
            ref={this.searchRef}
            value={this.state.search}
            placeholder={t('calendar:dropdownList.searchPlaceholder')}
            autoComplete="off"
            onChange={this.handleInput}
          />
        </span>
      )
    }
  }

  renderSelectAll() {
    const { filters, options, name, selectAllText, explicit, t } = this.props
    if (options.hasSelectAll) {
      const names = this.props.name.split(' ')
      let item = {}
      if (this.props.isNotification || explicit) {
        item = {
          text: explicit
            ? t('calendar:dropdownList.allBuildings')
            : t('calendar:dropdownList.toAll'),
          avatar: this.props.options.filterAllAvatar,
        }
      } else {
        item = {
          text: selectAllText || 'All ' + names[names.length - 1] + 's',
          avatar: this.props.options.filterAllAvatar,
        }
      }

      return (
        <SidebarItem
          item={item}
          isSelected={
            explicit
              ? filters.length === this.props.items.length
              : options.selectAllByDefault && filters[name].length === 0
          }
          type={'dropdown'}
          onSelect={this.handleSelectAll}
          controls={true}
          isFilter={true}
        />
      )
    }
  }

  renderDropdownItems() {
    const { items, filters, name, explicit, t } = this.props
    const { search } = this.state
    const filteredItems = items.filter((item) => {
      return !search || item.text.toLowerCase().includes(search.toLowerCase())
    })

    if (filteredItems.length === 0) {
      return (
        <p className="ctp-sidebar-dropdown-none"> {t('calendar:dropdownList.noItemsAvailable')} </p>
      )
    }
    return filteredItems.map((item, i) => {
      let index = 0
      if (explicit) index = filters.map((el) => el.id).indexOf(item.id)
      else index = filters[name].map((el) => el.id).indexOf(item.id)
      const isSelected = index >= 0
      return (
        <SidebarItem
          key={i}
          item={item}
          type={'dropdown'}
          isSelected={isSelected}
          onSelect={this.handleSelect}
          controls={true}
          isFilter={false}
        />
      )
    })
  }

  render() {
    const { variant } = this.props
    const name = this.props.label ? this.props.label : this.props.name
    const classModifier = this.state.opened ? '--active' : ''
    return (
      <div className="ctp-sidebar-section" ref={(ref) => (this.wrapperRef = ref)}>
        <div className={`ctp-dropdown ${variant ? `ctp-dropdown--${variant}` : ''}`}>
          <button className="ctp-dropdown__button" onClick={this.handleClick} type="button">
            <span>{name}</span>
            <Icon icon="arrow" className="ctp-dropdown__button-control" />
          </button>
          <div className={`ctp-dropdown__content${classModifier}`}>
            {this.renderSearch()}
            <div className="ctp-dropdown__options">
              {this.renderSelectAll()}
              {this.renderDropdownItems()}
            </div>
          </div>
        </div>
        {this.renderSelection()}
      </div>
    )
  }
}

DropdownList.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.array,
  options: PropTypes.object,
  filters: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  selectAllText: PropTypes.string,
  isNotification: PropTypes.bool,
  explicit: PropTypes.bool,
  onSearch: PropTypes.func,
  variant: PropTypes.oneOf(['rounded']),
  sidebarOption: PropTypes.bool,
  t: PropTypes.func,
}

export default withTranslation(['calendar'])(DropdownList)
